__turbopack_context__.v({
  "checkbox-group": "CheckboxList-module-scss-module__0SYfsG__checkbox-group",
});
